/**
 * Partially masks an email address for display.
 * @param email - The email address to mask
 * @returns The masked email string
 */
export function maskEmail(email: string): string {
  const [local, domain] = email.split('@');
  const domainParts = domain.split('.');
  const maskedLocal = local.slice(0, 2) + '****' + local.slice(-1);
  const maskedDomain = '****.' + domainParts[domainParts.length - 1];
  return `${maskedLocal}@${maskedDomain}`;
}
